import { Component, HostBinding, input, Input, output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { IconComponent, IconName } from '@cumlaude/shared-components-icons';

type SidebarSizeClass = 'size-30-vw' | 'size-20' | 'size-22' | 'size-23' | 'size-25' | 'size-34' | 'size-44' | 'size-47';

@Component({
	selector: 'app-base-sidebar',
	templateUrl: './base-sidebar.component.html',
	styleUrl: './base-sidebar.component.scss',
	imports: [NgTemplateOutlet, IconComponent],
})
export class BaseSidebarComponent {
	@Input()
	topBarTemplate?: TemplateRef<any>;

	@Input()
	bottomBarTemplate?: TemplateRef<any>;

	@HostBinding('class')
	@Input()
	sizeClass: SidebarSizeClass = 'size-30-vw';

	readonly noPadding = input<boolean>(false);

	readonly icon = input<IconName | undefined>(undefined);

	readonly sidebarTitle = input<string>();

	// Bewust 'close': het sluitgedrag van de sidebar in de templates (close)="…".
	// eslint-disable-next-line @angular-eslint/no-output-native
	close = output<Event>();

	iconClick = output<Event>();
}
